import { createContext, useState } from "react";
import useDatabase from "../hooks/useDatabase";
import Option from '../types/Option'

interface Entities {
  anillado: any;
  color: any;
  faz: any;
  hoja: any;
  papel: any;
  status: any;
}

interface EntitiesOptions {
  anillado: Option[];
  color: Option[];
  faz: Option[];
  hoja: Option[];
  papel: Option[];
  status: Option[];
}

export interface EntitiesContextProps {
  refreshEntities: any;
  refreshEntity: any;
  getEntities: any;
  entities: any;
  entitiesOptions: EntitiesOptions;
  loading: boolean;
  loadingCollection: string | null;
}

export const EntitiesContext = createContext(null);

export const EntitiesContextProvider = ({ children }: any) => {
  const { getCollection } = useDatabase();

  const [loading, setLoading] = useState<boolean>(false);
  const [loadingCollection, setLoadingCollection] = useState<string | null>('');
  const [initialLoad, setInitialLoad] = useState<boolean>(true);

  const [entities, setEntities] = useState<Entities>({
    anillado: [],
    color: [],
    faz: [],
    hoja: [],
    papel: [],
    status: []
  });

  const [entitiesOptions, setEntitiesOptions] = useState<EntitiesOptions>({
    anillado: [],
    color: [],
    faz: [],
    hoja: [],
    papel: [],
    status: [],
  });

  const getOptions = (items: any): Option[] => {
    return items.map((item: any) => ({ value: item.id, text: item.name }))
  }

  const refreshEntities = async () => {
    setLoading(true);

    const entities = {
      anillado: await getCollection("anillado"),
      color: await getCollection("color"),
      faz: await getCollection("faz"),
      hoja: await getCollection("hoja"),
      papel: await getCollection("papel"),
      status: await getCollection("status"),
    };

    const options = {
      anillado: getOptions(entities.anillado), 
      color: getOptions(entities.color).filter(item => item.value === 1),
      faz: getOptions(entities.faz),
      hoja: getOptions(entities.hoja),
      papel: getOptions(entities.papel),
      status: getOptions(entities.status),
    }

    setLoading(false);
    setEntities(entities);
    setEntitiesOptions(options)
  };

  const getEntities = async () => {
    if (initialLoad) {
      await refreshEntities()
      setInitialLoad(false)
    }
  }

  const refreshEntity = async (collection: string) => {
    setLoadingCollection(collection);

    setEntities({
      ...entities,
      [collection]: await getCollection(collection),
    });

    setLoadingCollection(null);
  };

  // Global State like "Redux"
  const contextProps: EntitiesContextProps = {
    refreshEntities,
    refreshEntity,
    getEntities,
    entities,
    entitiesOptions,
    loading,
    loadingCollection,
  };

  return (
    // @ts-ignore
    <EntitiesContext.Provider value={contextProps}>
      {children}
    </EntitiesContext.Provider>
  );
};
